import React from 'react';
import PropTypes from 'prop-types';

import './styles/PageHeader.scss';

const PageHeader = ({ title, subtitle, className }) => {
  return (
    <div className={`${className} pageHeader`}>
      <h1 className="pageHeader-title">
        { title }
      </h1>
      {
        subtitle &&
          <span className="pageHeader-subtitle">
            { subtitle }
          </span>
      }
    </div>
  );
}

PageHeader.defaultValues = {
    title: 'Titre principal',
}

PageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    className: PropTypes.string,
}

export default PageHeader;




// WEBPACK FOOTER //
// ./src/components/PageHeader.jsx